import Vuex from "vuex";

import { Vue } from "@/public/utils/customVue";

let $edApi = Vue.prototype.$edApi;

import { encodePrefix } from "@/public/utils/tool";
// module
import publicStore from "@/public/store/publicStore";
import team from "./modules/team";
import tplCenter from "./modules/tplCenter";
import userPage from "./modules/userPage";
import bindPhoneDialog from "../app/store/modules/bindPhoneDialog";
import userNotifyMsg from "./modules/userNotifyMsg";
import cloudFile from "./modules/cloudFile";
import history from "./modules/history";
import star from "./modules/star";
import shareToMe from "./modules/shareToMe";
import publish from "./modules/publish";
import collect from "./modules/collect";
import recycle from "./modules/recycle";

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        publicStore,
        team,
        tplCenter,
        userPage,
        bindPhoneDialog,
        userNotifyMsg,
        cloudFile,
        history,
        star,
        shareToMe,
        publish,
        collect,
        recycle,
    },

    state: {
        isAd: false, // 追踪ad渠道
        initLang: false, // 登录用户初始设置lang
        themeIndex: 0,
        firstEnterNewpage: true, // 记录是否首次进入推荐页
        recommendList: [], // 新建页所有推荐的分类
        userInfo: null,
        starter: null,
        pcVersion: "",
        pcLockStatus: false,
        isOpenMyColud: false,
        pcSaveInput: false,
        pcFileName: "",
        pcVip: false,
        pcSliderFitWidth: 180,

        showPreviewTemp: false,
        showShareCode: false,
        shareLink: "",
        shareLinkCode: "",
        shareHTML: "",
        shareId: "",
        shareData: {},
        shareState: false,
        showLoading: false,

        showOpenFilesDialog: false,
        selectId: 0,
        domain: "",
        appState: "",

        workClassName: "",

        winobj: {},

        layoutMode: "grid",

        selectFilesIndex: [],
        shareTipState: false,

        layoutTop: 0,
        layoutLeft: 0,
        fileContextShow: false,
        teamContextShow: false,
        folderContextShow: false,

        thumbnail: {
            state: false,
            src: "",
            top: 10,
            left: 10,
        },
        thumbnailTimer: null,

        showFileSelector: false,
        showGroupFileSelector: false,

        selectMovePrefix: "",
        showImportModal: false,
        showLimitFileModal: false,
        collectModal: false,
        limitFileModalType: "create",
        limitFileModalFlag: true,
        limitFileNum: 3,
        limitFileNowFileNum: 0,
        visioLimit: 0, // visio已免费转换次数

        showPublish: false,
        publishFileList: [],
        pcLang: "",
        trackClass: "all",
        showPopAd: false,
        testOpenTemplate: false, // 增长性实验，可以直接打开的模板则直接打开，不进入预览页面
        workFilter: {
            suggest: false, //我的推荐
            follow: false, //我关注的
            offset: 0,
            count: 30,
            order: "PV", // TIME | PV | LIKE
            sort: "DESC", // DESC | ASC
            classId: 0,
            price: 1, // 1全部 2免费 3付费 4会员免费
            lang: "zh",
            search: "",
            tag: [],
            album: null,
        },
        baseOrder: "PV", // zh=PV, en=TIME
        activeLv1: null,
        activeLv2: null,
        activeLv3: null,
        trackTemplateWay: "fromCommunity", // 模板来源埋点
        workBrenchIndex: 0,
        showDialog: false,
        showDialogMask: false,
        dialogType: null,

        showTopbar: false,
        showFloat: false,
        showAlert: false,
        showFileItemTagStrModal: false,
        activeFileItemIndex: -1,
        openWinList: [],
        buy618: false,
        locatTagStr: "",
        forceSearch: false, // 场景：新建搜索到社区，直接调用搜索
        buy520: false,
        showVideoModal: false,
        newUserVideo: null, // 入门视频地址
        videoTitle: "",
        videoSrc: "",
        showReleasesModal: false,
        isNewUser: false,
        isNewUserVideo: false,
        showCouponModal: false,
        isPCDarkMode: 0,
        tagList: [],
        templateSelect: "index",
        tagId: NaN,
        reportMenu: false,
        fromAllTags: false,
        activeMenu: NaN,
        showSearch: false,
        showPublishSelector: false,

        showMiniprogram: false,
        miniprogramLeft: 0,
        miniprogramTop: 0,
        miniprogramDirection: 0, // 上下左右 位运算第一位控制上下，第二位控制左右
        isSelectSingleColudFile: true, // 选中单个云文件
        currentPath: "", // 云文件当前路径
        currentPathId: "", // 云文件当前路径id
        shareType: 0,
        shareExpire: {},
        shareUseable: 0,
        shareMembers: [],
        filePreview: false,
        message: {
            sponsor: "",
            title: "",
            type: 0,
            time: 3,
            imgType: 0,
            content: "",
            uniqueListenr: false,
            btnType: 0,
        },
        showMsg: false,
        medalIds: [],
        showLeftPanel: false,
        hasCreditMoney: false,
        showReadOnlyModal: false, // 仅预览文件弹窗
        readOnlyTempFileLink: null, // 仅预览暂存文件

        showPromotionBox: false,
        promotionBox: {
            type: "",
            left: 0,
            top: 0,
            direction: 0,
        },
        worksCount: 0,
        mfreeWorksCount: 0,

        showTeamList: false,
        showPreviewModal: false,
        showPreviewModalID: 0,
        isSearchMode: false,
        showTagsAll: true,
        mutOpenList: [],
        showUsertag: false, // 控制弹出顺序
        last_template_name: "",
    },
    mutations: {
        setDialogState(state, obj) {
            if (Array.isArray(obj.data)) {
                state[obj.type].splice(0, state[obj.type].length, ...obj.data);
            } else {
                state[obj.type] = obj.data;
            }
            if (obj.type === "showDialog" && obj.data === false) {
                state.showDialogMask = false;
                state.dialogType = null;
            }
            if (obj.type === "showSketch") {
                if (obj.data) {
                } else {
                    if (!state.showDialog) {
                        state.showDialogMask = false;
                    }
                }
            }
        },
        openOnlineSupport(state, payload) {
            const { internal } = payload;
            if (internal) {
                window.open("https://msg.wondershare.cc/qidian_edrawmax_client.html");
            } else {
                if (window["wsCrmChatbotApi"] && window["wsCrmChatbotApi"].click2HandleChatbot) {
                    window["wsCrmChatbotApi"].click2HandleChatbot();
                }
            }
        },
        setMiniProgram(state, obj) {
            state.showMiniprogram = obj.show;
            state.miniprogramLeft = obj.left;
            state.miniprogramTop = obj.top;
            state.miniprogramDirection = obj.direction;
        },
        setPromotionBox(state, obj) {
            state.showPromotionBox = obj.show;
            state.promotionBox.type = obj.type;
            state.promotionBox.left = obj.left;
            state.promotionBox.top = obj.top;
            state.promotionBox.direction = obj.direction;
        },
        showDialogMaskState(state) {
            state.showDialogMask = true;
        },
        hideDialogMaskState(state) {
            state.showDialogMask = false;
        },
        playVideo(state, obj) {
            state.showVideoModal = true;
            state.videoTitle = obj.title;
            state.videoSrc = obj.src;
        },
        setShowPreview(state, show) {
            state.showPreviewTemp = show;
        },
        pcFileName(state, pcFileName) {
            state.pcFileName = pcFileName;
        },
        initUserInfo(state, payload) {
            let newInfo = JSON.parse(payload);
            newInfo.islogin = newInfo.islogin === "true" ? true : false;
            state.pcVip = newInfo.vip;
            state.userInfo = newInfo;
            let ts: any = this;
            ts._vm.$bus.$emit("getStorage");
        },
        toUserInfo(state, payload) {
            if ((<any>window).qt || (<any>window).$qt) {
                //PC传过来的islogin是字符串的false
                if (payload.islogin === "false") {
                    payload.islogin = false;
                } else if (payload.islogin === "true") {
                    payload.islogin = true;
                    // state.storage.max = payload.max_storage + "M";
                    state.pcVip = payload.vip;
                    // //是PC的情况下，要等待解析完毕，app值为vue实例后再defineProperty
                    // setTimeout(() => {
                    //     Object.defineProperty(app, '$v_', { value: payload.vip });
                    // }, 0);
                }
            }
            state.userInfo = payload;
        },
        invalidToken(state) {
            state.userInfo.islogin = false;
        },
        changeLayout(state, layout) {
            if (!layout) {
                state.layoutMode = state.layoutMode == "grid" ? "list" : "grid";
            } else {
                state.layoutMode = layout;
            }
            localStorage.setItem("max_layoutMode", state.layoutMode);
        },
        initLayout(state) {
            if (localStorage.getItem("max_layoutMode")) {
                state.layoutMode = localStorage.getItem("max_layoutMode");
            }
        },
        setPcLockStatus(state, payload) {
            state.pcLockStatus = payload;
        },
        setThumbState(state, payload) {
            state.thumbnail[payload.type] = payload.data;
        },
        selectFile(state, payload) {
            state.selectFilesIndex = [payload];
        },
        selectFiles(state, payload) {
            let index = state.selectFilesIndex.indexOf(payload);
            if (index === -1) {
                state.selectFilesIndex.push(payload);
            } else {
                state.selectFilesIndex.splice(index, 1);
            }
            if (state.selectFilesIndex.length > 1) {
                state.isSelectSingleColudFile = false;
            } else {
                state.isSelectSingleColudFile = true;
            }
        },
        setDomain(state, payload) {
            state.domain = payload;
        },
        setAppState(state, val) {
            state.appState = val;
        },
        setState(state, obj) {
            state[obj.type] = obj.data;
        },
        logout(state, obj) {
            if (state.userInfo.qq || state.userInfo.weixin) {
                document.cookie = "EDUid=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
                document.cookie = "EDUid=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=" + state.domain;
            }
            state.userInfo = "";
            document.cookie = "EDCurrent=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
            document.cookie = "EDCurrent=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=" + state.domain;
            document.cookie = "EDSession=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
            document.cookie = "EDSession=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=" + state.domain;
        },
        changePublishFolderStatus(state, prefix) {
            let findFold = (arr, prefix) => {
                if (arr.length == 0) return;
                for (let i = 0; i < arr.length; i++) {
                    let target = arr[i];
                    if (target.type == "folder") {
                        if (target.prefix == prefix) {
                            target.status = !target.status;
                            return;
                        } else {
                            findFold(target.child, prefix);
                        }
                    }
                }
            };
            findFold(state.publishFileList, prefix);
        },
        updateWorkFilter(state, obj) {
            Object.assign(state.workFilter, obj);
        },
        cleanActiveLab(state, activeLv1) {
            state.activeLv1 = activeLv1;
            state.activeLv2 = null;
            state.activeLv3 = null;
        },
        addWin(state, win) {
            state.openWinList.push(win);
        },
        initSearchTemplates(state, payload) {
            const ts: any = this;
            ts._vm.$bus.$emit("resetSearchData");
            sessionStorage.setItem("search_keyword", payload.keyword);
            if (payload.local_list.length > 50 || payload.classify_list.length > 50) {
                // 打开或创建名为 pc_search_db 的 IndexDB 数据库
                let request = indexedDB.open("pc_search_db", 1);
                // 创建或更新数据库结构
                request.onupgradeneeded = function (event: any) {
                    let db = event.target.result;
                    // 创建一个名为 pc_search_tb 的对象存储空间（表）
                    let objectStore = db.createObjectStore("pc_search_tb", { keyPath: "name" });
                    if (!objectStore.indexNames.contains("search_classify_list")) {
                        objectStore.createIndex("search_classify_list", "search_classify_list", { unique: false });
                        objectStore.add({ name: "search_classify_list", search_classify_list: payload.classify_list });
                    }
                    if (!objectStore.indexNames.contains("search_local_list")) {
                        objectStore.createIndex("search_local_list", "search_local_list", { unique: false });
                        objectStore.add({ name: "search_local_list", search_local_list: payload.classify_list });
                    }
                };
                request.onsuccess = function (event: any) {
                    let db = event.target.result;
                    let transaction = db.transaction("pc_search_tb", "readwrite");
                    let objectStore = transaction.objectStore("pc_search_tb");
                    let request1 = objectStore.get("search_classify_list");
                    let p1 = new Promise((resolve) => {
                        request1.onsuccess = function (event) {
                            let data = event.target.result;
                            data.search_classify_list = payload.classify_list;
                            objectStore.put(data);
                            resolve();
                        };
                    });
                    let request2 = objectStore.get("search_local_list");
                    let p2 = new Promise((resolve) => {
                        request2.onsuccess = function (event) {
                            let data = event.target.result;
                            data.search_local_list = payload.local_list;
                            objectStore.put(data);
                            resolve();
                        };
                    });
                    Promise.all([p1, p2]).then(() => {
                        ts._vm.$bus.$emit("initSearchTemplates", payload);
                    });
                };
                request.onerror = function () {
                    console.log("Error opening database");
                };
                sessionStorage.setItem("search_classify_list", null);
                sessionStorage.setItem("search_local_list", null);
            } else {
                sessionStorage.setItem("search_classify_list", JSON.stringify(payload.classify_list));
                sessionStorage.setItem("search_local_list", JSON.stringify(payload.local_list));
                ts._vm.$bus.$emit("initSearchTemplates", payload);
            }
            this.commit("setShowPreview", false);
        },
        toHomeTemplates(state, payload) {
            console.log("toHomeTemplates", payload);
            const ts: any = this;
            this.commit("setShowPreview", false);
            sessionStorage.setItem("home_templates_name", JSON.stringify(payload));
            ts._vm.$bus.$emit("homeTemplates", payload);
        },
        toAlbumAll(state) {
            state.isSearchMode = true;
            state.showTagsAll = true;
            const newURL = new URL(location.href);
            newURL.searchParams.set("tags", "all");
            window.history.replaceState(history.state, "", newURL.href);
        },
        toAlbumID(state, payload) {
            this.commit("setState", {
                type: "trackTemplateWay",
                data: "fromSearchEntrance",
            });
            state.isSearchMode = true;
            state.showTagsAll = false;
            state.tagId = payload;
            const newURL = new URL(location.href);
            newURL.searchParams.set("tags", payload);
            window.history.replaceState(history.state, "", newURL.href);
        },
    },
    getters: {
        apiParam: (state) => {
            let params = {};
            //     fileKey = state.fileKey,
            //     targetFileKey = state.targetFileKey;
            //文件信息
            // params.curFileKey = fileKey;
            // params.curFilePath = fileKey.substring(
            //     fileKey.indexOf("Personal") + 9,
            //     fileKey.length
            // );
            // params.curFileName =
            //     fileKey && fileKey.match(/\/([^%#?&/]+)\.emmx$/)[1];

            // params.targetFileKey = targetFileKey;
            // params.targetFilePath = targetFileKey.substring(
            //     targetFileKey.indexOf("Personal") + 9,
            //     targetFileKey.length
            // );
            // params.targetFileName =
            //     targetFileKey && targetFileKey.match(/\/([^%#?&/]+)\.emmx$/)[1];
            // //个人信息
            let { user_id: id, user_name: userName, nick_name: nickName, token, lang, islogin } = state.userInfo || {};
            params = Object.assign(params, {
                id,
                token,
                userName,
                nickName,
                lang,
                islogin,
            });
            //语言和地区
            return params;
        },
        showFileNumTips: (state) => (ts) => {
            let publicStore = (state as any).publicStore;
            const vipState = ts.isPC ? state.pcVip : publicStore.vip;
            const limitFileNum = state.limitFileNum;
            const limitFileNowFileNum = state.limitFileNowFileNum;
            const isOverLimit = limitFileNowFileNum >= limitFileNum;
            const showFileNumTips = state.userInfo && state.userInfo.islogin && !vipState && isOverLimit;
            return showFileNumTips;
        },
    },
    actions: {
        getUserInfo({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                $edApi
                    .getUserInfo(getters.apiParam)
                    .then((res) => {
                        resolve(res);
                        res.data.token = state.userInfo.token;
                        Object.assign(state.userInfo, res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getFloder({ state, getters, rootState }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(
                    {
                        prefix: encodePrefix(obj.prefix),
                        platform: rootState["publicStore"].runPlatform,
                        version: state.pcVersion,
                    },
                    getters.apiParam
                );
                $edApi
                    .getFolder(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getFolders({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                // level 最大支持 3
                let params = Object.assign({ prefix: encodePrefix(obj.prefix), level: 2 }, getters.apiParam);
                $edApi
                    .getFolders(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        searchFile({ state, getters, commit, rootState }, obj) {
            let runplatform = rootState["publicStore"].runPlatform;
            return new Promise((resolve, reject) => {
                let params = Object.assign({ w: obj.value, platform: runplatform }, getters.apiParam);
                $edApi
                    .searchFile(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        uploadFile({ state, getters, commit, rootState }, obj) {
            let runplatform = rootState["publicStore"].runPlatform;
            return new Promise((resolve, reject) => {
                let params = Object.assign(
                    {
                        obj: obj.name,
                        size: obj.file.size,
                        encrypt: obj.encrypt || 0,
                        platform: runplatform,
                        cover: obj.cover,
                    },
                    getters.apiParam
                );
                if ((this as any)._vm.isPrivate) {
                    params = Object.assign(params, {
                        name: obj.fileName,
                        platform: "web",
                        folder_id: obj.folderId,
                    });
                    if (obj.action == "cover") {
                        Object.assign(params, {
                            file_key: obj.file_key,
                        });
                    }
                }
                $edApi
                    .getCloudFileSign(params)
                    .then((res) => {
                        if (res.msg === "file num over limit") {
                            commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: "fileNum",
                            });
                            reject("overLimit");
                        } else if (res.msg === "storage space not enough") {
                            reject("storage space not enough");
                        } else if (res.msg == "read only") {
                            reject("read only");
                        } else {
                            let filePath = res.data.obj;
                            let ossParams = {
                                url: filePath,
                                exp: res.data.exp,
                                sign: res.data.sign,
                                file: obj.file,
                                contentType: "application/octet-stream",
                            };
                            let newFileName = filePath.split("/")?.pop()?.split(".")?.[0] || obj.fileName;
                            $edApi.uploadOSSFile(ossParams).then((res) => {
                                if ((this as any)._vm.isPrivate) {
                                    let fileObj = `${filePath}&name=${newFileName}`;
                                    resolve({ res, path: fileObj });
                                } else {
                                    resolve({ res, path: filePath });
                                }
                            });
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadFiles({ state, getters }, obj) {
            let key = obj.key;
            let filePath = key.match(/[^\/]+\/[^\/]+\/(.+)/) && key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
            return new Promise((resolve, reject) => {
                let params = Object.assign({ obj: filePath }, getters.apiParam);
                if ((this as any)._vm.isPrivate) {
                    Object.assign(params, {
                        file_key: obj.info.file_key,
                    });
                }
                $edApi
                    .getDownFileAddress(params)
                    .then((res) => {
                        let ossParams = {
                            url: key,
                            sign: res.data.sign || res.data.query,
                            exp: res.data.exp,
                            responseType: "blob",
                        };
                        $edApi
                            .downloadOSSFile(ossParams)
                            .then((res) => {
                                resolve(res);
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        delFiles({ state }, obj) {
            let files = obj.files;
            return new Promise((resolve, reject) => {
                let params = {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                    obj: files.key,
                    modified: files.lastModified,
                    etag: files.eTag,
                    type: files.type,
                    size: files.size,
                    storage: files.storageSize,
                };
                $edApi
                    .delFiles(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        delFilesBatch({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(obj, {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                });
                $edApi
                    .delFilesBatch(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        delFolder({ state, getters }, obj) {
            let folder = obj.folder;
            return new Promise((resolve, reject) => {
                let params = Object.assign({ obj: folder.prefix }, getters.apiParam);
                $edApi
                    .delFolder(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        move({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ from: obj.filePath, to: obj.newPath }, getters.apiParam);
                $edApi
                    .moveObj(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        moveDir({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                if (obj.from === obj.to) {
                    resolve("samePath");
                }
                let params = Object.assign(obj, {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                });
                $edApi
                    .moveObjDir(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        moveBatch({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(obj, {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                });
                $edApi
                    .moveObjBatch(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        copyDir({ state, getters, rootState }, obj) {
            let runplatform = rootState["publicStore"].runPlatform;
            return new Promise((resolve, reject) => {
                let params = Object.assign(obj, {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                    platform: runplatform,
                });
                $edApi
                    .copyObjDir(params)
                    .then((res) => {
                        if (res.data.status === "success") {
                            resolve(res);
                        } else {
                            reject(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        copyBatch({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(obj, {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                });
                $edApi
                    .copyObjBatch(params)
                    .then((res) => {
                        if (res.data.status === "success") {
                            resolve(res);
                        } else {
                            reject(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        rename({ state, getters }, obj) {
            let files = obj.files;
            let filePath = "",
                newPath: any = "";

            let params = { id: getters.apiParam.id, token: getters.apiParam.token };
            if ((this as any)._vm.isPrivate) {
                Object.assign(params, {
                    file_key: files.info.file_key,
                    name: obj.name,
                });
            } else {
                filePath = files.key.match(/[^\/]+\/[^\/]+\/(.+)/) && files.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                newPath = filePath.split("/");
                newPath[newPath.length - 1] = obj.name + ".eddx";
                newPath = newPath.join("/");
                Object.assign(params, { from: filePath, to: newPath });
            }
            return new Promise((resolve, reject) => {
                $edApi
                    .moveObj(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        renameFolder({ state, getters }, obj) {
            let folder = obj.folder;
            let prefixPath = (folder.prefix.match(/[^\/]+\/[^\/]+\/(.+)/) && folder.prefix.match(/[^\/]+\/[^\/]+\/(.+)/)[1]) || "";
            if (prefixPath) {
                let arr = prefixPath.split("/");
                arr.length = arr.length - 2;
                prefixPath = arr.length ? arr.join("/") + "/" : "";
            }
            let folderPath = prefixPath + folder.name + "/";
            let newPath = prefixPath + obj.name + "/";
            return new Promise((resolve, reject) => {
                let params = Object.assign({ from: folderPath, to: newPath }, getters.apiParam);
                $edApi
                    .moveFolder(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        createFolder({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ prefix: obj.prefix }, getters.apiParam);
                $edApi
                    .createFolder(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getShareList({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ fileType: "eddx" }, getters.apiParam);
                $edApi
                    .getShareList(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        cancelShare({ getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ fileId: obj.fileId }, getters.apiParam);
                $edApi
                    .cancelShare(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getRecycleData({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                $edApi
                    .getRecycleData(getters.apiParam)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        delRecycleFolderBatch({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(obj, getters.apiParam);
                $edApi
                    .delRecycleFolderBatch(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        delRecycleFolder({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ folderId: obj.id, platform: obj.platform }, getters.apiParam);
                $edApi
                    .delRecycleFolder(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        recycleFolderBatch({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(obj, getters.apiParam);
                $edApi
                    .recycleFolderBatch(params)
                    .then((res) => {
                        if (res.data.msg === "file num over limit") {
                            reject("overLimit");
                        } else {
                            resolve(res);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        recycleFolder({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ folderId: obj.id }, getters.apiParam);
                $edApi
                    .recycleFolder(params)
                    .then((res) => {
                        if (res.data.msg === "file num over limit") {
                            reject("overLimit");
                        } else {
                            resolve(res);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getTemplate({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = { tempInfo: "template", class_id: obj.class_id, type: obj.type, sourceCancelToken: obj.sourceCancelToken };
                $edApi
                    .getTemplateInfo(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getTemplatecls({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = { tempInfo: "templatecls2" };
                $edApi
                    .getTemplateInfo(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        searchTem({ state }, obj) {
            return new Promise((resolve, reject) => {
                $edApi
                    .searchTem(obj)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getTemplateNum({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = { tempInfo: "templatenum" };
                $edApi
                    .getTemplateInfo(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getLikeList({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                    tempInfo: "like",
                };
                $edApi
                    .getUserTempInfo(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getCollectList({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                    tempInfo: "collect",
                };
                $edApi
                    .getUserTempInfo(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        useTemplate({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: state.userInfo.user_id,
                    tempId: obj.template_id,
                    token: state.userInfo.token,
                };
                $edApi
                    .useTemplate(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        collectTemplate({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                    tempInfo: "collect",
                    tempId: obj.template_id,
                };
                $edApi
                    .updateUserTempInfo(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        likeTemplate({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                    tempInfo: "like",
                    tempId: obj.template_id,
                };
                $edApi
                    .updateUserTempInfo(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        setStarFile({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                    start_tag: obj.type,
                    obj_id: obj.id,
                };
                if ((this as any)._vm.isPrivate) {
                    Object.assign(params, {
                        file_key: obj.file_key,
                    });
                }
                $edApi
                    .setStar(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getMaxConfig({ state }, obj) {
            return new Promise((resolve, reject) => {
                $edApi
                    .getMaxConfig()
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getUserLimit({ state }, platform) {
            return new Promise((resolve, reject) => {
                let params = { id: state.userInfo.user_id, token: state.userInfo.token, platform };
                $edApi
                    .getUserLimit(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        setLang({ state }, obj) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: state.userInfo.user_id,
                    token: state.userInfo.token,
                    language: obj.lang,
                };
                $edApi
                    .setLang(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        reloadStore() {
            let ts: any = this;
            ts._vm.$bus.$emit("updateFilter", {
                album: null,
                page: 1,
                offset: 0,
            });
            ts._vm.$bus.$emit("closePreview");

            this.commit("toTplCenter", {
                name: "activeAlbumID",
                data: -1,
            });
            this.commit("toTplCenter", {
                name: "albumPageStatus",
                data: "default",
            });
            ts._vm.$bus.$emit("initWorkClass");
            ts._vm.$Modal.remove();
        },
        getSpecialTags({ state, commit }, lang) {
            return new Promise((resolve, reject) => {
                $edApi
                    .getSpecialTags(lang)
                    .then((data) => {
                        commit("setState", {
                            type: "tagList",
                            data,
                        });
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getMedalIds({ commit }) {
            $edApi.getMedalIds().then((res) => {
                commit("setState", {
                    type: "medalIds",
                    data: res,
                });
            });
        },
        getWorksCount({ commit }) {
            $edApi.getWorksCount().then((data) => {
                commit("setState", {
                    type: "worksCount",
                    data: data.work_num,
                });
                commit("setState", {
                    type: "mfreeWorksCount",
                    data: data.mfree_work_num,
                });
            });
        },
        getAllTemplates() {
            return new Promise((resolve, reject) => {
                $edApi
                    .getAllTemplates()
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getRecommendTemplates({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ pre_tpl_ids: obj.pre_tpl_ids }, getters.apiParam);
                $edApi
                    .getRecommendTemplates(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getRecommendTemplatesNotLogin({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ pre_tpl_ids: obj.pre_tpl_ids });
                $edApi
                    .getRecommendTemplatesNotLogin(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getRecommendConfig({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({}, getters.apiParam);
                $edApi
                    .getRecommendConfig(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateRecommendConfig({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(
                    {
                        sub_ids: obj.sub_ids,
                    },
                    getters.apiParam
                );
                $edApi
                    .updateRecommendConfig(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getDefaultTemplate({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(
                    {
                        type: obj.type,
                    },
                    getters.apiParam
                );
                $edApi
                    .getDefaultTemplate(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getDefaultTemplateNotLogin({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({
                    type: obj.type,
                });
                $edApi
                    .getDefaultTemplateNotLogin(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
});
